// extracted by mini-css-extract-plugin
var _1 = "MoreActionsButton-moduleaction__dN5A3";
var _2 = "MoreActionsButton-moduleactions__lS2E2";
export { _1 as "action", _2 as "actions" }
